"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRowHeight = void 0;
exports.getRowHeight = function (galleryHeight, margin, rows, galleryBottomPadding) {
    var totalMargins = margin * (rows - 1);
    return Math.max(Math.floor((galleryHeight - totalMargins - galleryBottomPadding) / rows), 0);
};
//# sourceMappingURL=gridCalculations.js.map